import React, { useEffect, useState } from 'react'
import { useTranslate } from './TranslationText'
import { formatDate } from '../helper/formatDate';

export default function RaceChampionCard({champCard}) {
    const { translate } = useTranslate();
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [windowWidtht, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowHeight(window.innerHeight);
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    
    return (
        <>
            <tr >
                {td(champCard?.fixtureDate,windowWidtht)}
                {td(champCard?.placing,windowWidtht)}
                {td(champCard?.winner ?? champCard.secondPlaceHorse,windowWidtht)}
                {td(champCard?.margin,windowWidtht)}
                {td(champCard?.winnerTime,windowWidtht)}
                {td(champCard?.racecourse,windowWidtht)}
                {td(champCard?.raceType,windowWidtht)}
                {td(champCard?.surfaceType,windowWidtht)}
                {td(champCard?.distance,windowWidtht)}
                {td(champCard?.jockey,windowWidtht)}
                {td(champCard?.trainer,windowWidtht)}
                {td(champCard?.stallNumber,windowWidtht)}
                {td(champCard?.horseRating,windowWidtht)}
                {td(champCard?.weight,windowWidtht)}
                {td(champCard?.startingPrice,windowWidtht)}
            </tr>
            {/* <div
                className={"col-lg-6 col-md-6 col-sm-12 mb-main"}
            >
                <div className={`hourseCardClass bg-White  p-main p-3 h-100 position-relative`}>

                    <div className="studBookHorseCompetitionDataContainer ">
                        <span className="horseCardTitle" style={{ minHeight: 45 }}>
                            {champCard?.raceName}
                        </span>
                    </div>

                    <div className="row rtl p0 text-start  ">

                        {cell(translate("web.raceDate", 'Race Date'), champCard?.fixtureDate)}
                        {cell(translate("web.raceNumber", 'Race Number'), champCard?.raceNumber)}
                        {cell(translate("web.rank", 'Rank'), champCard?.placing)}
                        {cell(translate("web.margin", 'Margin'), champCard?.margin)}
                        {cell(translate("web.winnerNd", 'Winner'), champCard?.winner)}
                        {!!champCard?.secondPlaceHorse &&
                            cell(translate("web.secondPlaceHorse", 'Second Place Horse'), champCard?.secondPlaceHorse)
                        }
                        {cell(translate("web.winnersTime", `Winner's Time`), champCard?.winnerTime)}
                        {cell(translate("web.raceCourse", `Race Course`), champCard?.racecourse)}
                        {cell(translate("web.raceType", `Race Type`), champCard?.raceType)}
                        {cell(translate("web.surfaceType", `Surface Type`), champCard?.surfaceType)}
                        {cell(translate("web.distance", `Distance`), champCard?.distance)}
                        {cell(translate("web.jockey", `Jockey`), champCard?.jockey)}
                        {cell(translate("web.trainer", `Trainer`), champCard?.trainer)}
                        {cell(translate("web.rating", `Rating`), champCard?.horseRating)}
                        {cell(translate("web.stallNumber", `Stall Number`), champCard?.stallNumber)}
                        {cell(translate("web.weight", `Weight`), champCard?.weight)}

                    </div>
                </div>
            </div> */}
        </>
    )
}
function cell(title, value) {
    return <div className="col-lg-3 col-md-6 col-sm-6 col-6 mb-2">
        <span className="horseCardTitle">
            {title}
        </span>
        <span className="horseCardDescription">
            {!!value ? value : '-'}
        </span>
    </div>;
}
function td(value , windowWidtht) {
    return <td className={`rtl text-center`}><div style={{ minWidth: windowWidtht < 1400? 150:60 }}>{!!value ? value : '-'}</div></td>;
}